import { render } from "./TablePagination.vue?vue&type=template&id=2bec4d92&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=ts"
export * from "./TablePagination.vue?vue&type=script&lang=ts"

import "./TablePagination.vue?vue&type=style&index=0&id=2bec4d92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bec4d92"

export default script